export const PetsPictures = [
    {
        "id": 1,
        "title" : "Creami",
        "description" : "Creami是这只猫猫的名字\nCreami is the cat's name.",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/D6vs/409c365b_IOMmvh4ZlYHJyGL.jpg",
        "pics" : [ {
          "src" : "https://s2.loli.net/2025/03/31/94sz7PW5rIghBdu.jpg",
          "description" : ""
        }, {
          "src" : "https://s2.loli.net/2025/03/31/zR8xYOUnsik29Cj.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/g2Cw/fd50a26d_KHuRcsSje3rkghL.jpg",
          "description" : ""
        }, {
          "src" : "https://s2.loli.net/2025/03/31/emv7yT8gjWUGR52.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/D6vs/409c365b_IOMmvh4ZlYHJyGL.jpg",
          "description" : ""
        } ]
      },
  {
    "id": 2,
    "title": "Chilli",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/08/04/9Uoh/cover.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/08/04/ihE2/139.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/9Uoh/cover.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/lrE9/IMG_5246.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/z6rF/IMG_5247.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/Ekr8/IMG_5248.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/sg6C/IMG_5249.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/rEn6/IMG_5250.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/i5Hj/IMG_5251.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/n8Rv/IMG_5252.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/9pGr/IMG_5253.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/sV7w/IMG_5254.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/N3oy/IMG_5255.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/2mfT/IMG_5256.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/nj3P/IMG_5257.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/6Dhc/IMG_5258.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/ol5C/IMG_5259.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/0kiC/IMG_5262.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/3Ncj/IMG_5263.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/mQ9n/IMG_5264.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/jkV9/IMG_5265.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/Sep8/IMG_5266.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/qB2p/IMG_5267.jpg",
        "description": ""
      }
    ]
  }
];